export default __webpack_public_path__ + "static/media/KissMark.677cc60a.svg";